export const TEXTS = { EMENU: 'e-menu', PREVIEW: 'Превью' };
